module.exports = __webpack_public_path__ + "img/59.fe701877.jpg";